import { apiClient } from '@/lib/api'
import type { Employee, EmployeeImportResult } from '@/types/employee'

export interface EmployeeWriteBody {
  name: string
  department: string
  // absent = no roster email (backend treats empty as null)
  email?: string
  hired_on: string
  // absent = currently employed (backend treats empty as null)
  terminated_on?: string
}

export function fetchEmployees() {
  return apiClient<Employee[]>('/employees')
}

export function createEmployee(body: EmployeeWriteBody) {
  return apiClient<Employee>('/employees', { method: 'POST', body })
}

export function updateEmployee(id: string, body: EmployeeWriteBody) {
  return apiClient<Employee>(`/employees/${id}`, { method: 'PUT', body })
}

export function deleteEmployee(id: string) {
  return apiClient<void>(`/employees/${id}`, { method: 'DELETE' })
}

// CSV bulk upload: the backend validates the whole file, then upserts rows
// matched to the existing roster by name.
export function importEmployees(file: File) {
  const form = new FormData()
  form.append('file', file)
  return apiClient<EmployeeImportResult>('/employees/import', { method: 'POST', body: form })
}
